import { computed } from 'vue';
import Config from '@/Config';

const availableCardBrands = Config.paymentProviders.adyen.availableCardBrands;

export function useAvailableCardBrands() {
    const cardBrands = computed(() => [
        {
            imgUrl: '/content/images/payments/card-icon-visa.svg',
            name: 'Visa',
            code: 'visa',
        },
        {
            imgUrl: '/content/images/payments/card-icon-mastercard.svg',
            name: 'Mastercard',
            code: 'mc',
        },
        {
            imgUrl: '/content/images/payments/card-icon-amex.svg',
            name: 'Amex',
            code: 'amex',
        },
        {
            imgUrl: '/content/images/payments/card-icon-jcb.svg',
            name: 'JCB',
            code: 'jcb',
        },
        {
            imgUrl: '/content/images/payments/card-icon-diners.svg',
            name: 'Diners',
            code: 'diners',
        },
        {
            imgUrl: '/content/images/payments/card-icon-discover.svg',
            name: 'Discover',
            code: 'discover',
        },
    ]);

    return {
        cardBrands: cardBrands.value.filter(i => availableCardBrands.includes(i.code)),
    };
}